import { useEffect, useState } from "react";
import axios from "axios";

const YouTubeVideoList = (props: { channelId: string; apiKey: string }) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(
          `https://www.googleapis.com/youtube/v3/search`,
          {
            params: {
              key: props.apiKey,
              channelId: props.channelId,
              part: "snippet",
              order: "date",
              maxResults: 4,
            },
          }
        );
        setVideos(res.data.items);
      } catch (err) {
        console.error("Failed to fetch videos", err);
      }
    };

    fetchVideos();
  }, [props.channelId, props.apiKey]);

  return (
    <div className="">
      {videos.map((video: any) => (
        <div key={video.id.videoId}>
          <iframe
            width="100%"
            height="200"
            src={`https://www.youtube.com/embed/${video.id.videoId}`}
            frameBorder="0"
            allowFullScreen
            title={video.snippet.title}
          ></iframe>
          <p>{video.snippet.title}</p>
        </div>
      ))}
    </div>
  );
};

export default YouTubeVideoList;
